import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    TextField,
    Typography,
    Box
} from '@mui/material';
import Scrollbars from 'react-custom-scrollbars-2';

export default function ConfirmDeleteVideoDialog({ open, onClose, video, onConfirm }) {
    const [step, setStep] = useState(1); // Step 1: Confirm, Step 2: Password
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleFirstConfirm = () => {
        setStep(2);
    };

    const handleFinalConfirm = (e) => {
        if (!password.trim()) {
            setError('Password is required');
            return;
        }
        onConfirm(e)(video.id, password);
        setStep(1);
        setPassword('');
        setError('');
        onClose();
    };

    const handleCancel = () => {
        setStep(1);
        setPassword('');
        setError('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleCancel} maxWidth="md" fullWidth>
            <DialogTitle>
                {step === 1 ? 'Delete Video?' : 'Enter Password'}
            </DialogTitle>

            <DialogContent>
                {step === 1 ? (
                    <>
                        <DialogContentText>
                            Are you sure you want to permanently delete the video{' '}
                            <strong>{video?.title || 'Untitled Video'}</strong>?
                            This action cannot be undone.
                            <Typography>Also all the files attached with this will be deleted such as :</Typography>
                            <Box p={1}>
                                {video.dropbox_link && (
                                    <Box>
                                        <strong>Dropbox</strong>
                                        <ul>
                                            <li><a href={video.dropbox_link} target='_blank'>{video.dropbox_link}</a></li>
                                        </ul>
                                    </Box>
                                )}
                                {video.thumbnail_url && (
                                    <Box>
                                        <strong>Thumbnail</strong>
                                        <ul>
                                            <li><a href={video.thumbnail_url} target='_blank'>{video.thumbnail_url}</a></li>
                                        </ul>
                                    </Box>
                                )}
                            </Box>
                        </DialogContentText>
                    </>
                ) : (
                    <>
                        <Typography variant="body2" gutterBottom>
                            Please enter your password to confirm deletion:
                        </Typography>
                        <TextField
                            autoFocus
                            margin="dense"
                            type="password"
                            label="Password"
                            fullWidth
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setError('');
                            }}
                            error={Boolean(error)}
                            helperText={error}
                        />
                    </>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCancel} color="secondary">
                    Cancel
                </Button>
                {step === 1 ? (
                    <Button onClick={handleFirstConfirm} color="error" variant="contained">
                        Confirm
                    </Button>
                ) : (
                    <Button onClick={handleFinalConfirm} color="error" variant="contained">
                        Delete Permanently
                    </Button>
                )}
            </DialogActions>
        </Dialog >
    );
}
